export const loadState = (key) => {
  try {
    const serilizedState = localStorage.getItem(key);
    if (serilizedState === null) {
      return undefined;
    }
    return JSON.parse(serilizedState);
  } catch (e) {
    return undefined;
  }
}

export const saveState = (key, value) => {
  try {
    const serilizedState = JSON.stringify(value);
    localStorage.setItem(key, serilizedState);
  } catch (e) {
    //ignore
  }
}

export const deleteState = (key) => {
  localStorage.removeItem(key);
}